// extracted by mini-css-extract-plugin
export default {"wrapper":"Heroes_wrapper__L6syW","left":"Heroes_left__pqnhp","right":"Heroes_right__z0EZw"};